import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetForestManagementQuery,
  usePublicGetForestManagementQuery,
  useGetForestManagementDefaultsQuery,
  usePublicGetForestManagementDefaultsQuery,
  useGetForestDisturbancesQuery,
  usePublicGetForestDisturbancesQuery,
  useGetForestDisturbancesDefaultsQuery, 
  usePublicGetForestDisturbancesDefaultsQuery,
  useUpdateForestManagementMutation,
  useUpdateForestDisturbanceMutation,
  useCreateForestDisturbanceMutation,
  useDeleteForestDisturbanceMutation
} from '../features/modules/forestManagementApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting forest management data based on the current route.
 */
export const useContextAwareGetForestManagement = createContextAwareHook(
  useGetForestManagementQuery,
  usePublicGetForestManagementQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting forest management defaults based on the current route.
 */
export const useContextAwareGetForestManagementDefaults = createContextAwareHook(
  useGetForestManagementDefaultsQuery,
  usePublicGetForestManagementDefaultsQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting forest disturbances based on the current route.
 */
export const useContextAwareGetForestDisturbances = createContextAwareHook(
  useGetForestDisturbancesQuery,
  usePublicGetForestDisturbancesQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting forest disturbances defaults based on the current route.
 */
export const useContextAwareGetForestDisturbancesDefaults = createContextAwareHook(
  useGetForestDisturbancesDefaultsQuery,
  usePublicGetForestDisturbancesDefaultsQuery
);

// Export mutation hooks directly
export {
  useUpdateForestManagementMutation,
  useUpdateForestDisturbanceMutation,
  useCreateForestDisturbanceMutation,
  useDeleteForestDisturbanceMutation
}; 